import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password);
      toast.success('Khush Aamdeed! 🌹');
    } catch (err) {
      toast.error(err.message || 'Login nahi hua');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-base)', padding: '20px', position: 'relative', overflow: 'hidden'
    }}>
      {/* Background decoration */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        background: 'radial-gradient(ellipse 60% 50% at 50% 0%, rgba(33,105,69,0.18) 0%, transparent 70%)'
      }} />
      <div style={{
        position: 'absolute', top: '20%', left: '10%', width: 300, height: 300,
        borderRadius: '50%', background: 'rgba(33,105,69,0.05)',
        filter: 'blur(60px)', pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute', bottom: '20%', right: '10%', width: 200, height: 200,
        borderRadius: '50%', background: 'rgba(196,154,0,0.06)',
        filter: 'blur(50px)', pointerEvents: 'none'
      }} />

      <div style={{
        width: '100%', maxWidth: 400, position: 'relative', zIndex: 1,
        animation: 'slideUp 0.4s ease'
      }}>
        {/* Logo area */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            width: 64, height: 64, margin: '0 auto 16px',
            background: 'linear-gradient(135deg, var(--emerald-800), var(--emerald-900))',
            border: '1px solid var(--emerald-600)', borderRadius: 16,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 28, boxShadow: '0 8px 32px rgba(42,128,85,0.3)'
          }}>☪️</div>
          <div style={{
            fontFamily: 'var(--font-display)', fontSize: 20,
            color: 'var(--gold-300)', letterSpacing: '1px', marginBottom: 4
          }}>
            HRN Admin Panel
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
            Allama Hassan Raza Naqshbandi
          </div>
        </div>

        {/* Login card */}
        <div style={{
          background: 'var(--bg-surface)', border: '1px solid var(--border-light)',
          borderRadius: 'var(--radius-lg)', padding: '32px 28px',
          boxShadow: '0 24px 60px rgba(0,0,0,0.5)'
        }}>
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="label">Username</label>
              <input
                className="input"
                placeholder="admin"
                value={form.username}
                onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
                autoFocus
              />
            </div>
            <div className="field">
              <label className="label">Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  className="input"
                  type={show ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={form.password}
                  onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                  style={{ paddingRight: 40 }}
                />
                <button
                  type="button"
                  onClick={() => setShow(s => !s)}
                  style={{
                    position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', color: 'var(--text-muted)',
                    cursor: 'pointer', fontSize: 14, padding: 2
                  }}
                >{show ? '🙈' : '👁️'}</button>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{ width: '100%', justifyContent: 'center', marginTop: 8, padding: '11px 16px', fontSize: 14 }}
            >
              {loading ? <span className="spinner" style={{ width: 16, height: 16 }} /> : '🔐'}
              {loading ? ' Checking...' : ' Login Karein'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 11, color: 'var(--text-muted)' }}>
          bot.allamahassanrazanaqshbandi.com
        </div>
      </div>
    </div>
  );
}